import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { colors } from '../../brand-colors';

function SocialModule() {
  const navigate = useNavigate();

  const contentTypes = [
    {
      id: 'long-form',
      title: 'Long Form Posts',
      icon: '📝',
      description: 'Blog posts, LinkedIn articles, Medium pieces. IP-level content that establishes authority.',
      path: '/command-center/campaign-hq/social/long-form',
    },
    {
      id: 'short-form',
      title: 'Short Form',
      icon: '🐦',
      description: 'LinkedIn posts, tweets, social media content for FB/X/Threads.',
      path: '/command-center/campaign-hq/social/short-form',
    },
    {
      id: 'pinterest',
      title: 'Pinterest',
      icon: '📌',
      description: 'Pin descriptions, visual content strategy.',
      muted: true,
      comingSoon: true,
    },
    {
      id: 'video-scripts',
      title: 'Video Scripts',
      icon: '🎬',
      description: 'Generate video scripts from blog posts or standalone topics. YouTube, TikTok, Reels.',
      path: '/command-center/campaign-hq/social/video-scripts',
    },
  ];

  const cardStyle = {
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: `1px solid ${colors.greyLight}`,
    height: '100%',
  };

  const iconStyle = {
    fontSize: '2.5rem',
    marginBottom: '1rem',
  };

  const titleStyle = {
    color: colors.greyDarkest,
    fontWeight: '600',
    fontSize: '1.1rem',
    marginBottom: '0.75rem',
  };

  return (
    <Container className="py-4">
      <div className="mb-4">
        <h1>Social Module</h1>
        <p className="text-muted">
          Generate authority-building content that positions you as a thought leader.
          Each piece is crafted using your unique voice, IP frameworks, and strategic thesis.
        </p>
      </div>

      <Row>
        {contentTypes.map((type) => (
          <Col key={type.id} lg={3} md={6} className="mb-4">
            <Card
              style={{
                ...cardStyle,
                ...(type.muted ? { opacity: 0.5, cursor: 'default' } : {}),
              }}
              className="shadow-sm"
              onClick={() => !type.muted && type.path && navigate(type.path)}
              onMouseEnter={(e) => {
                if (!type.muted) {
                  e.currentTarget.style.borderColor = colors.goldMid;
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }
              }}
              onMouseLeave={(e) => {
                if (!type.muted) {
                  e.currentTarget.style.borderColor = colors.greyLight;
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.transform = 'translateY(0)';
                }
              }}
            >
              <Card.Body className="text-center p-4">
                <div style={iconStyle}>{type.icon}</div>
                <div style={titleStyle}>{type.title}</div>
                <Card.Text className="text-muted small mb-0">
                  {type.description}
                </Card.Text>
                {type.comingSoon && (
                  <div className="mt-2">
                    <span className="badge bg-secondary">Coming Soon</span>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default SocialModule;
